module.exports = __webpack_public_path__ + "img/5.5995a83d.jpg";